import {Buffer} from 'buffer';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UntilDestroy} from '@ngneat/until-destroy';
import {AuthenticationService} from '~core/services';

/**
 * Login component, handles the log in of the user.
 */
@UntilDestroy()
@Component({template: ''})
export class LoginExternalComponent implements OnInit, OnDestroy {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {
  }

  public ngOnDestroy(): void {
  }

  public ngOnInit(): void {
    this.route.params
      .subscribe(params => {
        this.authenticationService.logout();
        const token: any = Buffer.from(params?.token, 'base64').toString('utf-8');
        localStorage.setItem('externalLogin', token);
        this.router.navigate(['/login']);
      });
  }
}
